"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Header = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("@paprika/stylers/lib/helpers");

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens/lib/tokens"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _typeKinds;

var typeKinds = (_typeKinds = {}, (0, _defineProperty2["default"])(_typeKinds, _button["default"].types.kind.DEFAULT, "background: ".concat(_tokens["default"].color.white, "; color: ").concat(_tokens["default"].color.black, ";")), (0, _defineProperty2["default"])(_typeKinds, _button["default"].types.kind.PRIMARY, "background: ".concat(_tokens["default"].color.purple, "; color: ").concat(_tokens["default"].color.white, ";")), _typeKinds);
var compactStyles = "\n  height: ".concat((0, _helpers.spacer)(6), ";\n  padding: ").concat(_tokens["default"].spaceLg, " ").concat((0, _helpers.spacer)(2), ";\n  \n  [data-pka-anchor=\"heading\"] {\n    margin: 0;\n  }\n");

var Header = _styledComponents["default"].div.withConfig({
  displayName: "Headerstyles__Header",
  componentId: "alzkw1-0"
})(function (_ref) {
  var kind = _ref.kind,
      hasPushedElement = _ref.hasPushedElement,
      isSlideFromLeft = _ref.isSlideFromLeft,
      isCompact = _ref.isCompact;
  return (0, _styledComponents.css)(["align-items:center;border-bottom:1px solid ", ";", " ", " box-sizing:border-box;display:flex;height:", ";justify-content:space-between;min-height:", ";padding:", " ", ";width:100%;&:focus{outline:0;}[data-pka-anchor=\"heading\"]{", " display:block;margin:0;}[data-pka-anchor=\"button.icon\"]{", "}", ";", ";"], _tokens["default"].border.color, hasPushedElement && !(kind === "primary") && isSlideFromLeft ? "border-right: 1px solid ".concat(_tokens["default"].border.color) : "", hasPushedElement && !(kind === "primary") && !isSlideFromLeft ? "border-left: 1px solid ".concat(_tokens["default"].border.color) : "", (0, _helpers.spacer)(8), (0, _helpers.spacer)(6), (0, _helpers.spacer)(2), (0, _helpers.spacer)(3), _stylers["default"].truncateText, kind === [_button["default"].types.kind.PRIMARY] ? "color: ".concat(_tokens["default"].color.white) : "color: inherit", isCompact ? compactStyles : "", kind ? typeKinds[kind] : "");
});

exports.Header = Header;
//# sourceMappingURL=Header.styles.js.map